import React, { useState, useEffect, useContext } from 'react';
import './AdminHome.css';
import { AuthContext } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CONFIG from '../config.js';

const AdminHome = () => {
    const { setFetchData, setShowNavLinks, setAdminSelectedUser } = useContext(AuthContext);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState();
    const [totalPages, setTotalPages] = useState(0);
    const [filteredUsersList, setFilteredUsersList] = useState();
    const [paginatedUsers, setPaginatedUsers] = useState([]);

    const url = CONFIG.createUrl();

    const config = {headers: CONFIG.HEADERS};

    const filterUsers = (newUsers, filterText) => {
        const filteredUsers = newUsers.filter(user =>
            (user.name && user.name.toLowerCase().includes(filterText.toLowerCase())) ||
            (user.email && user.email.toLowerCase().includes(filterText.toLowerCase()))
        );
        setFilteredUsersList(filteredUsers);
    }

    useEffect(() => {
        if (filteredUsersList && filteredUsersList.length) {
            setTotalPages(Math.ceil(filteredUsersList.length / pageSize));
            setPaginatedUsers(filteredUsersList.slice(
                (currentPage - 1) * pageSize,
                currentPage * pageSize
            ));
        }
    }, [filteredUsersList, currentPage]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(`${url}users?page=1&page_size=100`, config);
                const sortedUsers = response.data.items
                    .filter(user => user.type === "user")
                    .sort((a, b) => {
                        if (a.first_name < b.first_name) return -1;
                        if (a.first_name > b.first_name) return 1;
                        return 0;
                    });
                setFetchData({});
                setUsers(sortedUsers);
                filterUsers(sortedUsers, '');
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to first page on new search
        filterUsers(users, e.target.value);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const onUserSelection = (user) => {
        setShowNavLinks(true);
        const userObj = {
            displayName: '',
            email: user.email,
            uuid: user.uuid,
        }
        setAdminSelectedUser(userObj);
        navigate('/home');
    }

    return (
        <div className="container">
            <div className="main-content">
                <section className="card">
                    {!loading && paginatedUsers &&
                        <div>
                            <div className="search-input-container">
                                <label className="search-input-label" htmlFor="searchUserInput">Search User:</label>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className="search-input"
                                    id="searchUserInput"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                />
                            </div>
                            <ul className="users-list">
                                {paginatedUsers.map((user, index) => (
                                    <div key={`user-detail-${index}`} className="user-detail-container" onClick={() => onUserSelection(user)}>
                                        <div className="user-detail-item">
                                            <div className="user-icon-container">
                                                {user.first_name.charAt(0).toUpperCase()}
                                            </div>
                                            {user.first_name &&
                                                <div className="user-detail">
                                                    <span>
                                                    {user.first_name.length <= 3
                                                        ? user.first_name
                                                        : user.first_name.slice(0, 3) + '*'.repeat(user.first_name.length - 3)}
                                                    </span>
                                                    {user.last_name &&
                                                    <span>, {user.last_name}</span>
                                                    }
                                                </div>
                                                }
                                            {user.email &&
                                                <div className="user-detail">
                                                    <span>
                                                    {(() => {
                                                        const email = user.email;
                                                        const atIndex = email.indexOf('@');
                                                        const lastDotIndex = email.lastIndexOf('.');
                                                        
                                                        if (atIndex === -1 || lastDotIndex === -1 || lastDotIndex < atIndex) return email;

                                                        const prefix = email.slice(0, 3);
                                                        const afterAt = email.slice(atIndex + 1, atIndex + 3);
                                                        const domainEnding = email.slice(lastDotIndex);
                                                        
                                                        const maskedLength = email.length - (3 + 1 + 2 + domainEnding.length); // 3 for prefix, 1 for @, 2 after @, rest is masked
                                                        const maskedPart = '*'.repeat(Math.max(0, maskedLength));

                                                        return `${prefix}@${afterAt}${maskedPart}${domainEnding}`;
                                                    })()}
                                                    </span>
                                                </div>
                                                }
                                        </div>
                                        <button className="chevron-right-button"><i className="fa-solid fa-chevron-right"></i></button>
                                    </div>
                                ))}
                            </ul>
                            <div className="pagination-container">
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <button
                                        key={`page-number-${index}`}
                                        className="page-number"
                                        onClick={() => handlePageChange(index + 1)}
                                        disabled={currentPage === index + 1}
                                    >
                                        {index + 1}
                                    </button>
                                ))}
                            </div>
                        </div>
                    }
                </section>
            </div>
        </div>
    );
}

export default AdminHome;